import { render } from "./ServiceDetails.vue?vue&type=template&id=63af11ea&scoped=true"
import script from "./ServiceDetails.vue?vue&type=script&lang=js"
export * from "./ServiceDetails.vue?vue&type=script&lang=js"

import "./ServiceDetails.vue?vue&type=style&index=0&id=63af11ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63af11ea"

export default script